<form #createPacienteForm="ngForm" (ngSubmit)="nextStep()">
    <header-form-cadastro-paciente [porcentagem]="porcentagem" [existeCadastro]="existeCadastro" />
    <div *ngIf="!existeCadastro">

        <div class="mt-3" [hidden]="step != 1">
            <verificar-cadastro-paciente #verificarPacienteForm />
        </div>

        <div class="mt-3" [hidden]="step != 2">
            <data-nascimento-form-cadastro-paciente #dataNascimentoForm />
        </div>

        <div class="mt-3" [hidden]="step != 3">
            <dados-form-cadastro-paciente #dadosFormCadastroPaciente [paciente]="paciente"
                [ehEstrangeiro]="paciente.ehEstrangeiro" />
        </div>

        <div class="mt-3" [hidden]="step != 4">
            <responsavel-form-cadastro-paciente #dadosResponsavel [model]="paciente"
                [ehEstrangeiro]="paciente.ehEstrangeiro" />
        </div>

        <div class="mt-3" [hidden]="step != 5">
            <aceita-termos-form-cadastro-paciente #termosUso />
        </div>

    </div>

    <div class="row d-flex justify-content-between align-items-center mt-4 mb-4" *ngIf="existeCadastro">
        <div class="col-12 align-items-center justify-content-center">
            <h3>Parece que você já possui cadastro em nossa plataforma.</h3>
        </div>
        <div class="col-12 align-items-center justify-content-center mt-4 mb-4">
            <span class=" login-recover">Deseja fazer
                <a routerLink="/account/login">login</a>
                ou
                <span id="recover-password" class="cursor-pointer" (click)="recuperarSenha()">recuperar sua
                    senha?</span>
            </span>
        </div>
    </div>

    <div class="row d-flex justify-content-between align-items-center mt-4">
        <div class="col-12 col-md-6">
            <button type="button" class="btn primary-white-button" (click)="back()">
                <i class="hgi hgi-stroke hgi-arrow-left-02"></i>
                Voltar
            </button>
        </div>

        <div class="col-12 col-md-6">
            <button *ngIf="!existeCadastro" [disabled]="saving" type="submit" class="btn primary-gold-button">
                <span *ngIf="step != maxStep">Continuar</span>
                <span *ngIf="step == maxStep">Cadastrar</span>
                <i *ngIf="step != maxStep" class="hgi hgi-stroke hgi-arrow-right-02 ml-2"></i>
            </button>
        </div>
    </div>

    <div *ngIf="!existeCadastro" class="col-12 text-center mt-4">
        <p>Já possui uma conta? <a routerLink="/account/login">Entrar</a></p>
    </div>
</form>